var CUSTOMER_PROFILE_FILTERS = [
    'person.firstName',
    'person.lastName',
    'person.dateOfBirth',
    'person.address.state',
    'person.address.zipcode',
    'person.phones.0.phoneNumber'
];
export default CUSTOMER_PROFILE_FILTERS;
//# sourceMappingURL=customerProfileFilters.js.map